import { render, staticRenderFns } from "./DrivewealthAccountSummaryView.vue?vue&type=template&id=6d923477&scoped=true"
import script from "./DrivewealthAccountSummaryView.vue?vue&type=script&lang=ts"
export * from "./DrivewealthAccountSummaryView.vue?vue&type=script&lang=ts"
import style0 from "./DrivewealthAccountSummaryView.vue?vue&type=style&index=0&id=6d923477&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d923477",
  null
  
)

export default component.exports